import React from 'react'
import Flex from 'components/Flex'
import Avatar from 'components/Avatar'
import Button from 'components/Button'

import { Empty } from 'antd'
import {RightArrow ,
  StyledFlex,
  Name,
  Address,
  Address1,
  NameAdd,
  FirstDiv,
  SecondDiv,
  SubContainer,
  VerticalDivider,
  NoDataText,
  CenterButton
}  from 'modules/Dashboard/Style/UpcomingListStyle'
import { Link, useNavigate  } from 'react-router-dom'
import moment from 'moment'
import NoEventsRole from 'components/icons/NoEventsRole.svg'


const UpcomingList = ({drivesList, studentDetails}) => {
  const navigate = useNavigate()

  const driveDetails = (event, param) => {
    navigate(`/driveDetails/${param?.roleId}/${param?.driveId}`)
  }
  const  checkDate = value =>{
    return moment(value).format('DD MMM')
  }
  const CheckDataDate = (item) =>{
    const data = item[item?.length-1]
    const dateValue = data?.studentInterviewTimeSlotMap?.[0]?.selectedDate
    const formattedDate = moment(dateValue).format('DD/MM/YYYY')
    return formattedDate
    
      }
  const CheckIcon = (logo,name) => {
    if (logo === null) {
      return (
        <Avatar
        background
        size={40}
        IconName={name[0]}
        font={18}
        />
      )
    } else {
      return <Avatar size={42} src={logo} />
    }
  }

  return (
    <>
        {drivesList?.list?.map((item, index) => (
        
          <StyledFlex spaceBetween centerVertically isDisplay={true} key={index+"list"}>
            <FirstDiv>
              <Flex centerVertically>
              {CheckIcon(item?.drive?.corporate?.logo,item?.drive?.corporate?.name)}
               
                <NameAdd column flexStart>
                  <Address>{item?.drive?.corporate?.name}</Address>
                  <Name>{item?.role?.tittle}</Name>
                </NameAdd>
                <SubContainer>
                  <Flex onClick={event => driveDetails(event,item)}>
                    <RightArrow />
                  </Flex>
                </SubContainer>
              </Flex>
            </FirstDiv>
            <SecondDiv>
              <Flex centerVertically>
                <Flex>
                {studentDetails?.isExpCandidate ?   <Address1>{CheckDataDate(item?.studentInterviewMap)}</Address1> :<Address1>{checkDate(item?.drive?.startDate)}</Address1>}
                 
                  <VerticalDivider type="vertical" />
                  <Address1>{item?.stage} </Address1>
                </Flex>
              </Flex>
            </SecondDiv>
          </StyledFlex>
        
      ))}
      {drivesList?.count === 0 ? (
        <>
        <br></br>
          <Empty
            image={NoEventsRole}
            description={<NoDataText>No Drives Scheduled</NoDataText>}
          />
 <CenterButton>
        <br></br>
     
        <Button.Secondary disabled={true} text={'View All'} width={'100px'} />
    
        <br></br>
        </CenterButton>
          </>
      ) :  
      <CenterButton>
        <br></br>
        <Link to="/drives">
        <Button.Secondary text={'View All'} width={'100px'} />
        </Link>
        <br></br>
      </CenterButton>
}
    </>
  )
}
export default UpcomingList
